// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"491139f0","213":"a1a5ef1c","239":"d0d06e70","455":"20eb2a7a"}[chunkId] + ".chunk.js";
};